<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('forms.inputs.productFamily')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="productFamilyParams.name"
                  value="productFamilyParams.name"
                  :label="$t('forms.inputs.productFamily')"
                >
                </va-input>
              </div>
            </div>

          <div class="row">
            <div class="flex md2 sm6 xs12">
              <va-button
                v-if="productFamilyParams.productFamilyId == ''"
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="save(productFamilyParams)"
              >
                {{ $t('menu.save') }}
              </va-button>
              <va-button
                v-else
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="update(productFamilyParams)"
              >
                {{ $t('menu.update') }}
              </va-button>
            </div>

            <div class="flex md3 sm6 xs12">
              <va-button
                v-if="productFamilyParams.productFamilyId == ''"
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="create(productFamilyParams)"
              >
                {{ $t('menu.saveNew') }}
              </va-button>
            </div>

            <div class="flex md2 sm6 xs12">
              <va-button
                medium
                inline
                color="#ff842b"
                icon="fa fa-chevron-left"
                class="ma-0"
                :to="{ name: 'product-families', params: {
                    current_page: this.$route.params.current_page, 
                    search: this.$route.params.search, 
                    perPage: this.$route.params.perPage }
                  } " 
              >
                {{ $t('menu.back') }}
              </va-button>
            </div>
          </div>

          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import ProductFamilyAPI from '@/services/ProductFamilyAPI'
import { showError } from '@/global'

export default {
  name: 'form-product-lines',
  components: {},
  data () {
    return {
      productFamilyParams: {
        productFamilyId: '',
        name: ''
      },
      product_family: ''
    }
  },
  mounted () {
    if (this.$route.params.id != undefined) {
      ProductFamilyAPI.getProductFamilyById(this.$route.params.id).then(response => {
        let res  = response.data.product_family

        this.productFamilyParams.productFamilyId = res.id
        this.productFamilyParams.name = res.name
      })
    }
  },
  methods: {
    save (productFamilyParams) {
      ProductFamilyAPI.createProductFamily(productFamilyParams).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.$router.push({name: 'product-families'})
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    create (productFamilyParams) {
      ProductFamilyAPI.createProductFamily(productFamilyParams).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        }),

        this.productFamilyParams.name = ""
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    update (productFamilyParams) {
      ProductFamilyAPI.updateProductFamily(productFamilyParams).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        }),
        
        this.$router.push({name: 'product-families'})
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    }
  }
}
</script>